/** 将map转换为list */
export const mapToList = function (map: any): Array<any> {
  const list = []
  for (const [key, value] of Object.entries(map)) {
    if (key === 'toString') continue
    const name = map.toString(value)
    list.push({ value, name, label: name })
  }
  return list
}

/** 用户 token */
export const TOKEN_KEY = 'token'
/** 是否自动登录 */
export const IS_AUTO_LOGIN = 'IS_AUTO_LOGIN'

/** 分析数据字典 */
export const SOURCE = {
  TYPE1: '0', // 智能推荐
  TYPE2: '1', // 医生端首页
  TYPE3: '2', // 病案端首页
  TYPE4: '3', // 医保清单
  toString(type: string | number): string {
    switch (type + '') {
      case SOURCE.TYPE1 + '':
        return '类型1'
      case SOURCE.TYPE2 + '':
        return '类型2'
      case SOURCE.TYPE3 + '':
        return '类型3'
      case SOURCE.TYPE4 + '':
        return '类型4'
      default:
        return '-'
    }
  },
}
export const SOURCE_LIST = mapToList(SOURCE)

